import React from 'react';
import { history } from '../../store';

const GetStarted = () => {
  return (
    <div className='bfm-get-started'>
      <div>
        <p className='bfm-section-header'>Shopping ideas to get you started</p>
        <p className='bfm-started-message-text'>Trending items, top picks, hot sales</p>
      </div>
        <button className='bfm-button' onClick={() => history.push('/buy-for-me-shopping-guide')}>SHOPPING GUIDE</button>
    </div>
  )
}

export default GetStarted;


/** WEBPACK FOOTER **
 ** ./src/components/BuyForMe/GetStarted.js
 **/